import clsx from 'clsx';
import {
  Folder,
  FileText,
  Share2,
  AlertTriangle,
  Sparkles,
} from 'lucide-react';
import { useStore, type View } from '../store.js';

interface Item {
  id: View;
  label: string;
  Icon: typeof Folder;
  badge?: (s: ReturnType<typeof useStore.getState>) => string | number | null;
}

const ITEMS: Item[] = [
  { id: 'dashboard', label: 'Folders', Icon: Folder },
  { id: 'editor', label: 'Editor', Icon: FileText },
  { id: 'constellation', label: 'Constellation', Icon: Share2 },
  {
    id: 'lint',
    label: 'Lint',
    Icon: AlertTriangle,
    badge: (s) => (s.errors.length + s.warnings.length) || null,
  },
  { id: 'build', label: 'Build', Icon: Sparkles },
];

export function ActivityBar() {
  const view = useStore((s) => s.view);
  const setView = useStore((s) => s.setView);
  const state = useStore();

  return (
    <nav
      aria-label="Activity"
      className="flex w-12 shrink-0 flex-col items-center gap-1 border-r border-ink-800 bg-ink-950 py-2"
    >
      {ITEMS.map(({ id, label, Icon, badge }) => {
        const b = badge?.(state);
        const active = view === id;
        return (
          <button
            key={id}
            aria-label={label}
            title={label}
            onClick={() => setView(id)}
            className={clsx(
              'relative flex h-10 w-10 items-center justify-center rounded-md transition-colors',
              active
                ? 'bg-ink-800 text-accent-500'
                : 'text-ink-500 hover:bg-ink-900 hover:text-ink-300',
            )}
          >
            <Icon size={18} strokeWidth={1.5} />
            {b !== null && b !== undefined && b !== 0 && (
              <span className="absolute -right-0.5 -top-0.5 mono rounded-full bg-accent-500 px-1 text-[9px] font-semibold text-ink-950">
                {b}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
